// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"144":"04d37374","192":"4e3d546b","444":"c19ee676"}[chunkId] + ".chunk.js";
};